import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import { CookingCategoriesTable } from './components';
import { BackButton } from 'components';





const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));


const CookingCategoryList = (props) => {
  const classes = useStyles();
  

  //const [uiLoading, setUiLoading] = useState(false);
  
  //const [menus, setMenus] = useState([]);
  // / authAdminMiddleWare(history, user);



  // The route carries no menuId, so the menu we came from is passed via link state.
  const menuId = props.location?.state?.menuId;

  return (
    <div className={classes.root}>
      <BackButton
        to={menuId ? `/menu/${menuId}` : '/mymenus'}
        label={menuId ? 'Menu' : 'My Menus'}
      />
      <div className={classes.content}>
        <CookingCategoriesTable  />
      </div>
    </div>
  );
  
};

CookingCategoryList.propTypes = {
  location: PropTypes.object
};

export default CookingCategoryList;
